<template>
    <div class="create-section">
		<div class="page_heading">
			<div class="col-5 module_heading">
				<span class="module_icon icon-mentor"></span>
	            <span class="module_title">Create User(s) By Email</span>
			</div>

			<div class="col-7 btn_container">
    			<button class="btn btn-primary" v-on:click="createUserByEmail">Save</button>
				<button class="btn btn-primary" v-on:click="cancel">cancel</button>
    		</div>
    	</div>
		<div class="content-section">
			<div class="row content-row">
				<div class="col-12 row">
					<div class="col-2 form-label">Add User(s) Email</div>
					<div class="col-9">
						<textarea class="email-field" v-model="emails"></textarea>
						<small>Enter comma separated emails ids to create bulk students</small>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'createUserByEmail',
    props: ['parentSpaceId'],
    data () {
      return {
        emails: ''
      }
    },

    mounted () {
    },

    computed: {
      currentInstitutionId () {
        let userObj = JSON.parse(localStorage.getItem('userobj'))
        let institutionId = this.parentSpaceId
        return institutionId || userObj.institutionId
      },

      loggedInUserId () {
        var userObj = JSON.parse(localStorage.getItem('userobj'))
        return userObj.uuid
      }
    },

    methods: {
      ...mapActions([
        'loadCreateUserByEmail'
      ]),

      cancel () {
        this.$router.push({ name: 'listUsers', params: { parentSpaceId: this.currentInstitutionId } })
      },

      createUserByEmail () {
        var formData = new FormData()
        formData.append('emails', this.emails)
        this.loadCreateUserByEmail({parentSpaceId: this.currentInstitutionId, emails: formData}).then(res => {
          console.log('Res:', res)
          if (res) {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Successfully created users for emails: ' + this.emails
            })
            return this.$router.push({ name: 'listUsers', params: { parentSpaceId: this.currentInstitutionId } })
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Oops! Something went wrong. Please try again. Note that this email might already be taken.'
            })
          }
        })
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/user/components/CreateUserByEmail.vue